import React from "react";
import { StarIcon } from "@heroicons/react/solid"; // Adjust the import based on where you're getting the StarIcon
import classNames from "classnames"; // To help with combining class names

const PointIcon = ({
  className,
  containerSize = "w-8 h-8",
  iconSize = "w-6 h-6",
}) => {
  return (
    <div
      className={classNames(
        "flex items-center justify-center bg-yellow-400 border-2 border-yellow-300 rounded-full shrink-0",
        containerSize,
        className
      )}
    >
      <StarIcon className={classNames(iconSize, "text-white")} />
    </div>
  );
};
export default PointIcon;
